"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResetTime = exports.axiosCompeteURL = exports.isValidUrl = exports.createGracefulPropsWithAxios = exports.createGracefulPropsWithFetch = void 0;
var lodash_1 = require("lodash");
var createGracefulPropsWithFetch = function (clonedRes, options) { return __awaiter(void 0, void 0, void 0, function () {
    var recordHeaders, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                recordHeaders = {};
                clonedRes.headers.forEach(function (value, key) {
                    var _a;
                    recordHeaders = __assign(__assign({}, recordHeaders), (_a = {}, _a[key.toLocaleLowerCase()] = value, _a));
                });
                _a = [__assign({}, (0, lodash_1.pick)(clonedRes, 'url', 'status'))];
                _b = { isError: !clonedRes.ok, headers: recordHeaders };
                return [4 /*yield*/, clonedRes.json()];
            case 1: return [2 /*return*/, __assign.apply(void 0, _a.concat([(_b.responseBody = (_c.sent()), _b.typeOfRequest = 'FETCH', _b.requestBody = options, _b.method = (options === null || options === void 0 ? void 0 : options.method) || '', _b)]))];
        }
    });
}); };
exports.createGracefulPropsWithFetch = createGracefulPropsWithFetch;
var createGracefulPropsWithAxios = function (res) {
    var _a;
    var lowerCaseHeaders = Object.keys(res.headers).reduce(function (value, key) {
        var _a;
        return (__assign(__assign({}, value), (_a = {}, _a[key.toLocaleLowerCase()] = res.headers[key], _a)));
    }, {});
    return {
        headers: lowerCaseHeaders,
        status: res.status,
        url: (0, exports.axiosCompeteURL)(res),
        isError: res.status < 200 || res.status >= 400,
        responseBody: res.data,
        typeOfRequest: 'AXIOS',
        method: res.config.method || '',
        requestBody: (_a = res.config) === null || _a === void 0 ? void 0 : _a.data,
    };
};
exports.createGracefulPropsWithAxios = createGracefulPropsWithAxios;
var isValidUrl = function (urlString) {
    try {
        return Boolean(new URL(urlString));
    }
    catch (e) {
        return false;
    }
};
exports.isValidUrl = isValidUrl;
var axiosCompeteURL = function (res) {
    var _a, _b;
    var baseUrl = (_a = res === null || res === void 0 ? void 0 : res.config.baseURL) === null || _a === void 0 ? void 0 : _a.trim();
    var url = ((_b = res === null || res === void 0 ? void 0 : res.config.url) === null || _b === void 0 ? void 0 : _b.trim()) || '';
    if (!(baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.length) || (0, exports.isValidUrl)(url)) {
        return url;
    }
    var base = baseUrl[baseUrl.length - 1].includes('/')
        ? baseUrl.substring(0, baseUrl.length - 1)
        : baseUrl; //remove trailing slash
    var path = !url[0].includes('/') ? "/".concat(url) : url; // add slash in starting
    return [base, path].join('');
};
exports.axiosCompeteURL = axiosCompeteURL;
var getResetTime = function (responseBody, headers) {
    var _a, _b;
    var deltaSeconds = (_b = (_a = responseBody === null || responseBody === void 0 ? void 0 : responseBody.rateLimitReset) !== null && _a !== void 0 ? _a : headers === null || headers === void 0 ? void 0 : headers['x-ratelimit-reset']) !== null && _b !== void 0 ? _b : 0;
    var resetTime = new Date();
    resetTime.setSeconds(resetTime.getSeconds() + deltaSeconds);
    return { resetTime: resetTime, deltaSeconds: deltaSeconds };
};
exports.getResetTime = getResetTime;
